import React from "react";
import { useDispatch } from "react-redux";
import { GeneralType } from "../../../../lib/types";
import TreasureBox from "./TreasureBox";
import { openContentPopup } from "../../../../store/actions";

import { generals } from "../../../../assets/images/generals";

interface IProps {
  generalType: GeneralType;
  generalsCount: number;
}

const ChooseTreasure = ({
  generalType,
  generalsCount
}: IProps) => {
  const dispatch = useDispatch();

  return (
    <>
      <h2 className="h2 h2-first">
        <span className="bordered">General in labyrinth</span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <div className="box">
          <div className="person-row row">
            <div className="col-md-8 col-sm-12 clearfix">
              <img src={generals[`general${generalType.typeId}`]} alt="" className="photo"/>
              <div className="pull-left">
                <h3 className="name">{generalType.general && generalType.general.name}
                  <span className="white"> – {generalType.typeName}</span>
                </h3>
                <p>
                  <span className="white">Level</span>&nbsp;&nbsp;
                  <em>{generalType.general && generalType.general.level}</em>
                  <br/>
                  <span className="white">Experience</span>&nbsp;&nbsp;
                  <em>{generalType.general && generalType.general.experience}</em>
                </p>
              </div>
            </div>
            <div className="col-sm-4 text-center clearfix">
              <a href="#"
                 className="btn btn-black btn-no-width pull-sm-right"
                 onClick={() => dispatch(openContentPopup({
                   name: "Labyrinth",
                   title: "Labyrinth",
                   icon: "labyrint"
                 }))}
              >
                Choose another
              </a>
            </div>
          </div>
        </div>
        <span className="divider"/>
      </section>

      <h2 className="h2 h2-first">
        <span className="bordered">Treasure choice</span>
      </h2>
      <span className="divider"/>
      <section className="boxes-group">
        <div className="box">
          {generalType.general && <div className="row persons labyrinth-treasures">
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Grain"}
              treasureInterval={generalType.general && generalType.general.labGrain}
              treasureCode={"grain"}
              imageCode={8}
              iconName={"obili"}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Gold"}
              treasureInterval={generalType.general && generalType.general.labGold}
              treasureCode={"gold"}
              imageCode={9}
              iconName={"zlato"}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Bricks"}
              treasureInterval={generalType.general && generalType.general.labBricks}
              treasureCode={"bricks"}
              imageCode={3}
              iconName={"infrastrukturni-body"}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Weapons"}
              treasureInterval={generalType.general && generalType.general.labWeapons}
              treasureCode={"weapons"}
              imageCode={10}
              iconName={"zbrane"}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Mana"}
              treasureInterval={generalType.general && generalType.general.labMana}
              treasureCode={"mana"}
              imageCode={11}
              iconName={"mana"}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Development"}
              fixedGain={"Gain: 1 technology point"}
              treasureCode={"science"}
              imageCode={1}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Experience"}
              fixedGain={`Gain: ${generalType.general && generalType.general.labExperience} XP for general`}
              treasureCode={"exp"}
              imageCode={6}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"Pops"}
              fixedGain={"Gain: +10 pop growth for 10 turns"}
              treasureCode={"people"}
              imageCode={2}
            />
            <TreasureBox
              generalId={generalType.general.id}
              treasureName={"General"}
              treasureCode={"gen"}
              imageCode={7}
              disabled={generalsCount >= 4}
            />
          </div>}
        </div>
        <span className="divider"/>
      </section>
    </>
  )
}

export default ChooseTreasure;
